<div class="header">
  <i class="fa fa-calendar-alt"></i>
  <br />
  Chọn khoảng thời gian bạn muốn xem.
</div>

<div class="options">

  <ng-container *ngFor="let col of cols">
    <div class="list" *ngIf="range || col == cols[0]">
      <ng-container *ngFor="let item of col">
        <div class="item" *ngIf="range || item.single" (click)="activate(item)" [ngClass]="{ 'active' : active == item }">{{item.name}}</div>
      </ng-container>
    </div>
  </ng-container>
</div>

<calendar *ngIf="customizable" [min]="active.range.from" [max]="active.range.to" [selected]="value ? value.from : null" (change)="activate(null, $event)" [display]="active == cols[0][2] ? 'days' : 'months'"></calendar>

